export const REDUCER_NAME="vendorsSlice";
export interface iVendorsDTO {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    mobile?: string;
    address?: string;
    password?:string;
    confirmPassword?:string;
    profilePicture?:string|File;    
}

export interface iShopInfoDTO {
    id?: string;
    shopName?: string;
    shopAddress?: string;
    shoplogo?:string|File; 
    shopbanner?:string|File; 
    shopsecbanner?:string|File;   
}


export interface iVendorWithShopDTO extends iVendorsDTO, iShopInfoDTO {
  userId: string;
  totalProducts?: number;
  totalOrders?: number;
  status?: number;
}

export interface iVendorsState {
    vendorsList: iVendorWithShopDTO[] | null;
    isLoading: boolean;
    errorMessage: string | null;
}

